export const CATEGORY_COLORS = {
  Groceries:     '#4db6ac', // teal — works in both themes
  Home:          '#7986cb', // indigo
  Entertainment: '#ff8a65', // deep orange
  Travel:        '#ffd54f', // amber
};

/** Shared chart palette — theme-neutral, used by ChartWrapper and screens. */
export const CHART_COLORS = ['#6A55F7', '#f59e0b', '#ef4444', '#3b82f6', '#10b981', '#8b5cf6', '#ec4899', '#14b8a6'];

/** Fallback monthly income used when no profile is loaded. */
export const MOCK_MONTHLY_INCOME = 5500;
